import { tempo, tempoDevnet, tempoLocalnet, tempoModerato } from 'wagmi/chains'

/** Returns the supported wallet-next chain ID for dashboard and funding surfaces. */
export function getSupportedChainId(chainId?: number | undefined) {
  if (localTempoEnabled && chainId === tempoLocalnet.id) return chainId
  if (chainId === tempo.id || chainId === tempoModerato.id) return chainId
  if (chainId === tempoDevnet.id) return tempoModerato.id
  if (shouldDefaultToTestnet()) return tempoModerato.id
  return tempo.id
}

/** Returns whether local wallet-next should force the connection back onto Moderato. */
export function shouldForceModerato(chainId?: number | undefined) {
  return import.meta.env.DEV && isLocalWalletHost() && chainId !== tempoModerato.id
}

/** Returns whether local wallet-next should default dashboard surfaces to testnet. */
export function shouldDefaultToTestnet() {
  return import.meta.env.DEV && isLocalWalletHost()
}

/** Whether local wallet-next should use the compose local Tempo node. */
export const localTempoEnabled = import.meta.env.VITE_LOCAL_TEMPO_ENABLED === 'true'

function isLocalWalletHost() {
  return typeof window !== 'undefined' && window.location.hostname.endsWith('.tempo.local')
}
